import React, { useEffect, useState } from "react";

const CrosswordEditComponent = ({ game_id, date, onCancel, challenge }) => {
  const CURRENT_SELECTED_CHALLENGE = challenge;
  const [challengeDict, setChallengeDict] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!game_id || !date) return;
    setLoading(true);
    setError(null);
    const url = `${process.env.REACT_APP_CMC_API}/statistics?method=getDailyChallengeComplex&gameid=${game_id}&date=${date}`;
    fetch(url, {
      headers: { Connection: "close" },
      credentials: "include",
    })
      .then((response) => {
        if (!response.ok) throw new Error("Failed to fetch complex challenge data");
        return response.json();
      })
      .then((json) => {
        if (json && json.challenge_name && Array.isArray(json.challenge_name)) {
          const dict = {};
          for (let i = 0; i < json.challenge_name.length; i++) {
            const name = json.challenge_name[i];
            if (!dict[name]) {
              dict[name] = {
                game_id: json.game_id?.[i],
                challenge_name: name,
                variants: {},
              };
            }
            const variant_name = json.variant_name?.[i];
            const variant_id = json.variant_id?.[i];
            const challenge_data = json.challenge_data?.[i];

            if (variant_name) {
              dict[name].variants[variant_name] = {
                variant_id: variant_id,
                challenge_data: challenge_data,
              };
            }
          }
          setChallengeDict(dict);
        } else {
          setChallengeDict(null);
        }
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [game_id, date]);
  
  const selectedChallenge = challengeDict?.[CURRENT_SELECTED_CHALLENGE];
  const dataData = selectedChallenge?.variants?.data?.challenge_data;
  const downData = selectedChallenge?.variants?.down?.challenge_data;
  const acrossData = selectedChallenge?.variants?.across?.challenge_data;

  const displayDownRaw = downData;
  const displayAcrossRaw = acrossData;

  let grid = [], numbers = [], size = 0;
  if (dataData) {
    const parts = dataData.split('-');
    if (parts.length >= 2) {
      grid = parts[0].split(',');
      numbers = parts[1].split(',').map(n => n === 'null' ? null : n);
      size = Math.sqrt(grid.length);
    }
  }
  
  const parseClues = (cluesStr) => {
    if (!cluesStr) return [];
    return cluesStr.split('|').map(c => {
        const parts = c.split('§');
        if (parts.length >= 3) {
            return `${parts[0]}. ${parts[2]}`;
        }
        return c;
    });
  };

  const displayDownClues = parseClues(displayDownRaw);
  const displayAcrossClues = parseClues(displayAcrossRaw);
  
  if (loading) return <div>Loading complex challenge data...</div>;
  if (error) return <div style={{ color: 'red' }}>Error: {error}</div>;

  return (
    <div className="p-3 rounded-xl mt-2">
        {/* Grid Preview */}
        <div>
            <div className="bg-gray-100 dark:bg-neutral-800 p-2 rounded-md max-w-xs mx-auto">
                {size > 0 ? (
                    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${size}, minmax(0, 1fr))`, gap: '2px' }}>
                        {grid.map((cell, index) => (
                            <div key={index} className={`aspect-square flex items-center justify-center relative ${cell === '#' ? 'bg-black' : 'bg-white dark:bg-neutral-700'}`}>
                                {cell !== '#' && <span className="text-black dark:text-white font-bold uppercase text-xs">{cell}</span>}
                                {numbers[index] && <span className="absolute top-0 left-0 text-[8px] text-gray-500 dark:text-gray-400 leading-none p-0.5">{numbers[index]}</span>}
                            </div>
                        ))}
                    </div>
                ) : <p className="text-xs text-neutral-500 text-center">No grid data.</p>}
            </div>
        </div>

        {/* Clues Preview */}
        <div className="mt-4">
            <div className="text-xs max-h-48 overflow-y-auto border dark:border-neutral-700 p-2 rounded-md bg-gray-50 dark:bg-neutral-800">
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <h4 className="font-semibold mb-1">Across</h4>
                        <ul className="list-none list-inside space-y-1">{displayAcrossClues.map((clue, i) => <li key={i}>{clue}</li>)}</ul>
                    </div>
                    <div>
                        <h4 className="font-semibold mb-1">Down</h4>
                        <ul className="list-none list-inside space-y-1">{displayDownClues.map((clue, i) => <li key={i}>{clue}</li>)}</ul>
                    </div>
                </div>
            </div>
        </div>
      
        <div className="flex justify-end gap-2 mt-4">
          <button title="Close" onClick={onCancel} className="bg-gray-50 hover:bg-gray-200 dark:bg-neutral-700 dark:hover:bg-neutral-600 p-2 rounded-md"><svg width="20" height="20" fill="none" stroke="#F8A5A5" strokeWidth="2" viewBox="0 0 24 24"><path d="M6 18L18 6M6 6l12 12"/></svg></button>
        </div>
    </div>
  );
};

export default CrosswordEditComponent; 